import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectService } from '../service/project.service';

@Component({
  selector: 'app-operating-expenses-table',
  templateUrl: './operating-expenses-table.component.html',
  styleUrls: ['./operating-expenses-table.component.css'],
})
export class OperatingExpensesTableComponent implements OnInit {
  constructor(private projectService: ProjectService) {
    this.projectId = localStorage.getItem('projectId');
  }
  // THIS COMPONENT IS CHILD COMPONENT OF OPERATING EXPENSES TO SHOW TABLES, BECAUSE WE NEED THIS FOR PRINTING ALSO TO SHOW 2 YEARS RECORDS

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Output() projectEmitOpex: EventEmitter<any> = new EventEmitter();

  @Output() opexEmit: EventEmitter<any> = new EventEmitter();

  @Input() parentObject: any = {};

  @Input() pageName: string;

  @Input() projectName: string;

  @Input() projectId = '';

  months: number[] = new Array();

  secondMonths: number[] = new Array();

  thirdMonths: number[] = new Array();

  start_up_month: number;

  ceiledStartUpYear: number;

  food_cost: number;

  year = 1;

  // DECLARATION OF FIRST YEAR DATA OF OPEX TABLE
  monthlyFirstYearData = [];

  monthlySecondYearData = [];

  monthlyThirdYearData = [];

  // DECLARATION & INITIALIZATION OF FIRST YEAR'S TOTALS OF OPEX TABLE
  opexFirstYearData = {
    gross_operating_income: 0,
    management_fee: 0,
    manager_salary: 0,
    manager_salary_percent_goi: 0,
    workers_comp_factor: 0,
    caregivers_wages: 0,
    chef: 0,
    cleaning_staff: 0,
    rent: 0,
    taxes: 0,
    insurance_property: 0,
    gas: 0,
    water_sewer: 0,
    electric: 0,
    garbage_removal: 0,
    landscaping_plowing: 0,
    exterminator: 0,
    business_license_renewal: 0,
    accounting_payroll_services: 0,
    hoa_fees: 0,
    food: 0,
    housekeeping_supplies: 0,
    office_supplies: 0,
    security_monitoring: 0,
    recreational_activities: 0,
    website_advertising: 0,
    referral_fees_start_up: 0,
    referral_fees_ongoing: 0,
    insurance_liability: 0,
    cable_internet_phone_newspapers: 0,
    repairs_maintenance: 0,
    transportation: 0,
    furniture_lease: 0,
    membership_fees: 0,
    total_payroll: 0,
    total_general: 0,
    total_caregiver_wages: 0,
    total_occupied_beds: 0,
    total_goi: 0,
    total_management_fee: 0,
    average_management_fee: 0,
    total_manager_salary: 0,
    average_manager_salary: 0,
    total_manager_salary_percent_goi: 0,
    average_manager_salary_percent_goi: 0,
    total_chef: 0,
    average_chef: 0,
    total_cleaning_staff: 0,
    average_cleaning_staff: 0,
    total_rent: 0,
    average_rent: 0,
    total_taxes: 0,
    average_taxes: 0,
    total_insurance_property: 0,
    average_insurance_property: 0,
    total_gas: 0,
    average_gas: 0,
    total_water_sewer: 0,
    average_water_sewer: 0,
    total_electric: 0,
    average_electric: 0,
    total_garbage_removal: 0,
    average_garbage_removal: 0,
    total_landscaping_plowing: 0,
    average_landscaping_plowing: 0,
    total_exterminator: 0,
    average_exterminator: 0,
    total_business_license_renewal: 0,
    average_business_license_renewal: 0,
    total_accounting_payroll_services: 0,
    average_accounting_payroll_services: 0,
    total_hoa_fees: 0,
    average_hoa_fees: 0,
    total_food: 0,
    average_food: 0,
    total_housekeeping_supplies: 0,
    average_housekeeping_supplies: 0,
    total_office_supplies: 0,
    average_office_supplies: 0,
    total_security_monitoring: 0,
    average_security_monitoring: 0,
    total_recreational_activities: 0,
    average_recreational_activities: 0,
    total_website_advertising: 0,
    average_website_advertising: 0,
    total_referral_fees_start_up: 0,
    average_referral_fees_start_up: 0,
    total_referral_fees_ongoing: 0,
    average_referral_fees_ongoing: 0,
    total_insurance_liability: 0,
    average_insurance_liability: 0,
    total_cable_internet_phone_newspapers: 0,
    average_cable_internet_phone_newspapers: 0,
    total_repairs_maintenance: 0,
    average_repairs_maintenance: 0,
    total_transportation: 0,
    average_transportation: 0,
    total_furniture_lease: 0,
    average_furniture_lease: 0,
    total_membership_fees: 0,
    average_membership_fees: 0,
    total_goi_year: 0,
    total_payroll_year: 0,
    total_payroll_year_goi: 0,
    total_general_year: 0,
    total_general_year_goi: 0,
    total_opex_year: 0,
    total_opex_year_goi: 0,
  };

  opexSecondYearData = { ...this.opexFirstYearData };

  opexThirdYearData = { ...this.opexFirstYearData };

  total_payroll_goi = [];

  total_general_goi = [];

  total_opex_goi = [];

  total_second_payroll_goi = [];

  total_second_general_goi = [];

  total_second_opex_goi = [];

  total_third_payroll_goi = [];

  total_third_general_goi = [];

  total_third_opex_goi = [];

  ngOnInit() {
    this.printingOpexData();
    for (let i = 1; i <= 12; i++) {
      this.months.push(i);
    }
    for (let i = 13; i <= 24; i++) {
      this.secondMonths.push(i);
    }
    for (let i = 25; i <= 36; i++) {
      this.thirdMonths.push(i);
    }
  }

  getProjectData() {
    this.projectService.getProject(this.projectId).subscribe((projectData) => {
      this.projectName = projectData.data[0].project_name;
      this.start_up_month = projectData.data[0].start_up_month;
      this.ceiledStartUpYear = Math.ceil(this.start_up_month / 12);
      this.food_cost = projectData.data[0].food_cost;

      this.parentObject.year = this.year;
      this.parentObject.food_cost = this.food_cost;
      this.parentObject.start_up_month = this.start_up_month;
      this.parentObject.ceiledStartUpYear = this.ceiledStartUpYear;
      this.projectEmitOpex.emit({ projectEmitOpex: true });
    });
  }

  printingOpexData() {
    this.projectService.getYearlyRecordsForPrinting(this.projectId).subscribe((res) => {
      this.opexFirstYearData = res.data.opexFirstYearData;
      this.opexSecondYearData = res.data.opexSecondYearData;
      this.opexThirdYearData = res.data.opexThirdYearData;
      this.monthlyFirstYearData = res.data.monthlyFirstYearData;
      this.monthlySecondYearData = res.data.monthlySecondYearData;
      this.monthlyThirdYearData = res.data.monthlyThirdYearData;

      for (const monthData of res.data.monthlyFirstYearData) {
        if (monthData.goi === 0) {
          this.total_payroll_goi.push(0);
          this.total_general_goi.push(0);
          this.total_opex_goi.push(0);
        } else {
          this.total_payroll_goi.push(monthData.total_payroll / monthData.goi);
          this.total_general_goi.push(monthData.total_general / monthData.goi);
          this.total_opex_goi.push(monthData.total_opex / monthData.goi);
        }
      }

      for (const monthData of res.data.monthlySecondYearData) {
        if (monthData.goi === 0) {
          this.total_second_payroll_goi.push(0);
          this.total_second_general_goi.push(0);
          this.total_second_opex_goi.push(0);
        } else {
          this.total_second_payroll_goi.push(monthData.total_payroll / monthData.goi);
          this.total_second_general_goi.push(monthData.total_general / monthData.goi);
          this.total_second_opex_goi.push(monthData.total_opex / monthData.goi);
        }
      }

      for (const monthData of res.data.monthlyThirdYearData) {
        if (monthData.goi === 0) {
          this.total_third_payroll_goi.push(0);
          this.total_third_general_goi.push(0);
          this.total_third_opex_goi.push(0);
        } else {
          this.total_third_payroll_goi.push(monthData.total_payroll / monthData.goi);
          this.total_third_general_goi.push(monthData.total_general / monthData.goi);
          this.total_third_opex_goi.push(monthData.total_opex / monthData.goi);
        }
      }
      this.opexEmit.emit({ opexEmit: true });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/operating-expenses-table/operating-expenses-table.component.ts